import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ModalParam } from '@/config/url-parameters';

/**
 * Hook to detect modal trigger URL parameters and manage modal state
 * Automatically cleans URL parameters after triggering modals
 */
export const useModalTrigger = (modalParam: ModalParam) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [shouldOpen, setShouldOpen] = useState(false);

  useEffect(() => {
    const paramValue = searchParams.get(modalParam);
    
    if (paramValue === 'true') {
      console.log(`[useModalTrigger] Detected ${modalParam} parameter, triggering modal`);
      setShouldOpen(true);
      
      // Clean URL after trigger - remove the parameter
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete(modalParam);
      
      // Update URL without the parameter
      setSearchParams(newSearchParams, { replace: true });
    }
  }, [modalParam, searchParams, setSearchParams]);

  // Reset shouldOpen after it's been consumed
  const resetTrigger = () => {
    setShouldOpen(false);
  };

  return { 
    shouldOpen, 
    setShouldOpen,
    resetTrigger 
  };
}; 